export default {
  name: { en: "Vogue Café Riyadh", ar: "Vogue Café Riyadh" },
  description: {
    en: "Vogue Café is simply the chicest dining experience in Riyadh. It is a destination for the modern and stylish to enjoy delicious coffee and light cuisine in an effortlessly chic environment.",
    ar: "Vogue Café is simply the chicest dining experience in Riyadh. It is a destination for the modern and stylish to enjoy delicious coffee and light cuisine in an effortlessly chic environment."
  },
  keywords: "VOGUE, Vogue café, Vogue cafe, Vouge, Vouge café, Vouge cafe, Voge, Fogue, Fog, Vog, Vogue café Riyadh, Vogue cafe Saudi, Riyadh park mall, Riyadh restaurant, Fashion, Trend, Restaurant, Find dining, Café, Coffee shop, Riyadh vibes, Vogue Arabia, Restaurants, Food, Dinner, Breakfast, Brunch, Lunch, Takeaway, Sweets, Cakes, Chocolate, Pastry, Bakery, Bread, فوغ كافيه, فوغ كافية, فوغ الرياض, فوغ, فوج كافيه, فوج كوفي, فوغ العربية, الرياض بارك, الرياض بارك مول, رياض بارك, مطاعم, مطاعم الرياض, مطعم, كوفي شوب, كافيهات, عشاء, غداء, فطور, حلويات, كيك, شكولاته, الرياض, اماكن الرياض, فوج العربية, مجلات فوغ العربية, مجلة فوج العربية",
  siteUrl: "https://voguecafe.sa/",
  twitterUser: "@voguecafe_sa",
  headerLogouUrl: "./content/images/headerLogo.png",
  siteBackgroundUrls: [
    "./content/images/background/05.jpg",
    "./content/images/background/36.jpg",
    "./content/images/background/26.jpg",
    "./content/images/background/06.jpg",
    "./content/images/background/03.jpg",
    "./content/images/background/04.jpg"
  ],
  headerMenus: [
    { title: { en: "Home", ar: "الرئيسية" }, url: "#cover" },
    { title: { en: "Menu", ar: "قائمة الطعام" }, url: "#menus" },
    { title: { en: "Reservations", ar: "الحجوزات" }, url: "#contact" },
    { title: { en: "Photos", ar: "الصور" }, url: "#gallery" },
  ],
  social: [
    { title: { en: "Instagram", ar: "انستقرام" }, icon: "fab fa-instagram fa-2x", url: "https://instagram.com/voguecaferiyadh" }
  ],
  linkToImage: [
    { title: { en: "Covid-19 Guidelines", ar: "Covid-19 Guidelines" }, id: "_image-overlay-covid19", url: "./content/images/covid19.png" },
    { title: { en: "FAQs", ar: "FAQs" }, id: "_image-overlay-faqs", url: "./content/images/faq.png" }
  ],
  makeReservationBtn: { title: { en: "Make a Reservation", ar: "احجز الآن" }, url: "#contact" },
  coverContent: {
    name: { en: "Vogue Café", ar: "Vogue Café" },
    imageUrl: "./content/images/headerLogo.png",
    subtitleLine: { en: "Riyadh\nSaudi Arabia", ar: "الرياض\nالمملكة العربية السعودية" },
    address: { en: "Riyadh Park Mall\nFirst Floor", ar: "مجمع الرياض بارك\nالدور الأول" }
  },
  introductionContent: {
    name: { en: "Vogue Café Riyadh", ar: "Vogue Café Riyadh" },
    subtitleLine: { en: "Food for the fashionable", ar: "Food for the fashionable" },
    description: [
      {
        en: "Offering a modern, elegant and stylish ambience together with food and drinks that are simply and beautifully crafted and presented, Vogue Café Riyadh gives you the opportunity to step inside the Vogue world, a world of excitement, luxury and timeless elegance.",
        ar: ""
      },
      {
        en: "With an all day menu representing the best of modern European cuisine and décor that feels like it has been lifted directly from the pages of the magazine, Vogue Café is the place for the fashionable to meet, connect and be seen.",
        ar: ""
      }
    ]
  },
  firstBreakImageUrl: "./content/images/UpBanner.jpg",
  secondBreakImageUrl: "./content/images/DownBanner.jpg",
  galleryContent: [
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/01.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/03.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/04.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/06.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/07.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/18.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/08.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/09.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1920", url: "./content/images/gallery/10.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/12.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/13.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/14.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/02.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/11.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/15.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/16.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/17.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1920", url: "./content/images/gallery/05.jpg" },
    { alt: { en: "", ar: "" }, size: "1920x1280", url: "./content/images/gallery/19.jpg" },
  ],
  contactContent: {
    name: { en: "Vogue Café", ar: "Vogue Café" },
    mapUrl: "https://goo.gl/maps/S1xEv3NQNeG2",
    mapImageUrl: "./content/images/mapImage.png",
    subtitleLine: { en: "Riyadh , Saudi Arabia", ar: "الرياض ، المملكة العربية السعودية" },
    address: { en: "Riyadh Park Mall\nFirst Floor\nRiyadh , Saudi Arabia", ar: "مجمع الرياض بارك\nالدور الأول\nالرياض ، المملكة العربية السعودية" },
    phone: { text: "(053) 381 7188", number: "+966533817188" },
    email: "info@globalseries.co",
    openingHours: {
      title: { en: "Opening Hours", ar: "مواعيد العمل" },
      description: { en: "Everyday 8:00 AM until 12:00 AM\nFriday 1:00 PM until 12:00 AM", ar: "يوميا من الساعة 8:00 صباحاً وحتى 12:00 منتصف الليل\nيوم الجمعة من الساعة 1:00 مساءاً وحتى 12:00 منتصف الليل" },
    }
  },
  footerContent: {
    company: {
      title: { en: "Condé Nast International Restaurants", ar: "Condé Nast International Restaurants" },
      imageUrl: "./content/images/cni-restaurants.png",
      url: "http://condenastinternationalrestaurants.com/"
    },
    businesses: [
      {
        title: { en: "Vogue Lounge", ar: "Vogue Lounge" },
        branches: [
          {
            title: { en: "Kuala Lumpur", ar: "Kuala Lumpur" },
            url: "http://voguelounge.my/",
          }
        ]
      },
      {
        title: { en: "Vogue Café", ar: "Vogue Café" },
        branches: [
          {
            title: { en: "Beijing", ar: "Beijing" },
            url: "http://www.voguecafebeijing.com/",
          },
          {
            title: { en: "Istanbul", ar: "Istanbul" },
            url: "https://voguerestaurantandbar.com/",
          },
          {
            title: { en: "Porto", ar: "Porto" },
            url: "https://voguecafe.pt/",
          },
          {
            title: { en: "Riyadh", ar: "Riyadh" },
            url: "http://voguecafe.sa/",
          },
          {
            title: { en: "Bangkok", ar: "Bangkok" },
            url: "https://www.voguecafe.co.th/",
          },
          {
            title: { en: "Shanghai", ar: "Shanghai" },
            url: "http://www.voguecafeshanghai.com/",
          }
        ]
      }
    ],
    disclaimer: {
      rights: {
        en: "© 2018 Condé Nast International Restaurants. All rights reserved.",
        ar: "© 2018 Condé Nast International Restaurants. All rights reserved."
      },
      privacyPolicy: {
        title: { en: "Privacy Policy", ar: "Privacy Policy" },
        url: "http://www.condenastinternational.com/initiatives/cond%C3%A9-nast-international-restaurants/"
      },
      description: {
        en: "The material on this site may not be reproduced, distributed, transmitted, cached or otherwise used, except with prior written permission of Condé Nast International Restaurants.",
        ar: "The material on this site may not be reproduced, distributed, transmitted, cached or otherwise used, except with prior written permission of Condé Nast International Restaurants."
      },
    }
  },
  menusContent: {
    title: { en: "Menu", ar: "قائمة الطعام" },
    footnotes: { en: "All prices are in Saudi Riyals. Prices are inclusive of 15% VAT.", ar: "جميع الأسعار المذكورة بالريال السعودي. الأسعار تشمل ضريبة القيمة المضافة." },
    menus: [
      {
        title: { en: "BREAKFAST", ar: "الفطور" },
        dishes: [
          {
            title: { en: "Eggs Benedict", ar: "بيض بينيدكت" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Poached eggs served on pancakes with guacamole smoked salmon, and hollandaise sauce",
              ar: "بيض بينيدكت يقدم على عجينة البانكيك مع جواكمولي الافوكادو،سلمون مدخن وصلصة الهولانديز"
            }
          },
          {
            title: { en: "Signature Omelet", ar: "سقنيتشر اومليت" },
            price: { en: "48", ar: "48" },
            description: {
              en: "Omelet mixture with bell peppers, mushrooms ,  spring onion .layered on a brioche bread . Adding hollandaise & pesto sauce on top",
              ar: "خليط اومليت مميز  مع انواع الفلفل الحلو ، الفطر ، وتقدم على خبز البريوش المحمص . مع صلصة الهولانديز والبيستو"
            }
          },
          {
            title: { en: "Truffle Sliders", ar: "ترافل  سلايدرز" },
            price: { en: "47", ar: "47" },
            description: {
              en: "Scrambled Eggs topped with beef sausages and mixed sautéed vegetables. Served with a side of mixed green salad.",
              ar: "قطعتين  من البيض المخفوق  بزيت الكمأة ، مع  قطع اللحم و الفطر والهليون"
            }
          },
          {
            title: { en: "Omelet Sandwich", ar: "أومليت ساندوتش" },
            price: { en: "47", ar: "47" },
            description: {
              en: "Omelet topped with turkey & mixed cheese, flavored with oregano in a tortilla wrap",
              ar: "ساندوتش بيض الأومليت بخبز التورتيا ، مع الديك الرومي وجبنة الموزاريلا"
            }
          },
          {
            title: { en: "Greek Omelet", ar: "أومليت يونانية" },
            price: { en: "46", ar: "46" },
            description: {
              en: "A mixture of omelet with feta cheese & sautéed onion , topped with a Greek Salad",
              ar: "بيض أومليت مخفوق بالسبانخ وجبنة الفيتا  مع خليط السلطة اليونانية الشهيرة"
            }
          },
          {
            title: { en: "Turkey  and cheese", ar: "تركي اند تشييز" },
            price: { en: "49", ar: "49" },
            description: {
              en: "Brioche bread, smoked turkey and gouda cheese with sundried tomato, strawberry jam and a green side salad",
              ar: "خبز بريوش ،ديك رومي مدخن مع جبنة الغودا والطماطم المجففة، بالإضافة الى مربى الفراولة وسلطة جانبية خضراء"
            }
          },
          {
            title: { en: "Halloumi Pesto Sandwich", ar: "حلومي بيستو  ساندوتش" },
            price: { en: "48", ar: "48" },
            description: {
              en: "Thyme labneh with grilled halloumi cheese topped with fresh thyme leaves, mint, tomatoes and sliced olives with pesto sauce",
              ar: "لبنة بالزعتر مع جبنة حلومي مشوية مغطاة بأوراق الزعتر الطازجة والنعناع والطماطم وشرائح الزيتون مع البيستو"
            }
          },
          {
            title: { en: "Scrambled Avocado", ar: "سكرامبلد افوكادو" },
            price: { en: "49", ar: "49" },
            description: {
              en: "Mix of hummus , scrambled eggs , avocado slices , served on toasted tartine bread",
              ar: "مزيج من الحمص والبيض المخفوق  مع شرائح الافوكادو  ويقدم على خبز التارتين المحمص"
            }
          },
          {
            title: { en: "Poached in Fatteh", ar: "بوشد إن فتـه" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Poached eggs on an eggplant fatteh mixture with chili butter",
              ar: "بيض بوشد  على خليط الفتة بالباذنجان  مع زبدة الفلفل الحار"
            }
          },
          {
            title: { en: "French Toast", ar: "فرينش توست" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Caramelized French toast served with mixed fresh berries. And your choice of chocolate sauce or maple syrup",
              ar: "التوست الفرنسي المحمص بالكراميل ويقدم مع التوت البري والفراولة ، مع اختيارك  من صوص الميبل او الشكولاتة"
            }
          },
          {
            title: { en: "The Pancake", ar: "ذا بانكيك" },
            price: { en: "46", ar: "46" },
            description: {
              en: "Traditional Pancakes , served with maple syrup",
              ar: "البانكيك التقليدي اللذيذ ، ويقدم مع صوص الميبل"
            }
          },
          {
            title: { en: "Granola", ar: "جرانولا" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Layers of passion fruit yogurt with combined  healthy granola . Topped by mix of fresh berries",
              ar: "طبقات من زبادي فاكهة الباشن  مع الجرانولا . مغطاة بمزيج من أنواع التوت الطازج وتقدم مع العسل"
            }
          },
          {
            title: { en: "Peanut Honey", ar: "بينت هوني" },
            price: { en: "64", ar: "64" },
            description: {
              en: "Crunchy brioche bread topped by mascarpone cheese &  peanut butter, drizzled by honey & dates",
              ar: "خبز البريوش المقرمش مغطى بجبنة الماسكربون وزبدة الفول السوداني الكريمية ، مع إضافة العسل و شرائح تمر السكري والتين المجفف،  ,ومزيج من أنواع التوت  الطازج"
            }
          },
        ]
      },
      {
        title: { en: "FOR SHARING", ar: "للمشاركة" },
        dishes: [
          {
            title: { en: "Risotto Balls", ar: "ريزوتو" },
            price: { en: "43", ar: "43" },
            description: {
              en: "Mushroom Risotto stuffed with cheese , combined with avocado mousse & mushroom sauce.",
              ar: "كرات الريزوتو محشية بالجبنة وتقدم مع صوص الفطر و  ألافوكادو"
            }
          },
          {
            title: { en: "Eggplant Fatteh", ar: "فتة  الباذنجان" },
            price: { en: "54", ar: "54" },
            description: {
              en: "A delicious combination of crispy bread, eggplant with a mixture of fatteh and pomegranate, topped with sumac and toasted pine nuts.",
              ar: "مزيج  لذيذ من الخبز المقرمش والباذنجان  مع خليط الفتة  والرمان ،السماق  وحبات الصنوبر  المحمصه"
            }
          },
          {
            title: { en: "Glazed Shrimps", ar: "قليزد روبيان" },
            price: { en: "59", ar: "59" },
            description: {
              en: "Glazed honey shrimp with mango mousse and chili sauce",
              ar: "روبيان مقرمش  مع موس المانجو وكريمة الفلفل الحار"
            }
          },
          {
            title: { en: "Crunchy Mousakhan", ar: "كرنشي مسخن" },
            price: { en: "47", ar: "47" },
            description: {
              en: "Delicious  musakhan fingers, wrapped in crunchy dough and served with tahini and sumac sauce.",
              ar: "أصابع مسخن  اللذيذة ، ملفوفة بعجينة مقرمشة وتقدم مع صوص الزبادي بالطحينه  والسماق"
            }
          },
          {
            title: { en: "Tenderloin bites", ar: "قطع التندرلوين" },
            price: { en: "68", ar: "68" },
            description: {
              en: "Skewers of grilled tenderloin beef with crispy potato & entrecote sauce",
              ar: "قطع  من ستيك التندرولين  المشوية  تقدم مع البطاطس المحمصة وصوص الانتيركوت"
            }
          },
          {
            title: { en: "Tuna Bites", ar: "تونا بايتس" },
            price: { en: "46", ar: "46" },
            description: {
              en: "Crispy tortilla bread stuffed with tuna corn mix and avocado served with  jalapeno sauce.",
              ar: "خبز التورتيلا المقرمش محشو بخلطة التونة  بالذرة مع الأفوكادو  ويقدم مع صوص الهالابينو الحار"
            }
          },
        ]
      },
      {
        title: { en: "LIGHT & SALADS", ar: "السلطات" },
        dishes: [
          {
            title: { en: "Crunchy Salad", ar: "سلطة الكرانشي" },
            price: { en: "56", ar: "56" },
            description: {
              en: "Crisp mix of cabbage & iceberg lettuce topped with marinated chicken, carrot, mint, almond, walnut, cherry tomato, raisin, green onion with sliced green apple. Served with  a peanut butter dressing",
              ar: "سلطة مقرمشة من الخضروات الطازجة مع المكسرات والزبيب المجفف والتفاح، وتقدم مع صوص الفول السوداني والدجاج المشوي"
            }
          },
          {
            title: { en: "Shrimp Quinoa Salad", ar: "سلطة الروبيان بالكينوا" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Layers of cooked quinoa topped with avocado topped with grilled shrimps. Served with lemon dressing & mango mousse",
              ar: "سلطة الروبيان والكينوا مع الافوكادو والمانجو ، تقدم مع صوص الليمون"
            }
          },
          {
            title: { en: "Caesar Salad", ar: "سلطة  سيزر" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Mix of romaine & frisee lettuce topped with grilled chicken , served with our Caesar dressing",
              ar: "مزيج من الخس الروماني مع شرائح الدجاج المشوي ، تقدم مع صوص السيزر"
            }
          },
          {
            title: { en: "Corn Salad", ar: "سلطة الذرة" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Grilled corn & quinoa seeds mixed with fetta cheese & cherry tomato. Combined with lemon dressing & honey",
              ar: "مزيج من الذرة مشوية مع الكينوا  المقرمشة و جبنة الفيتا  والخيار وتقدم مع صوص الليمون بالعسل"
            }
          },
          {
            title: { en: "Thai Kale Salad", ar: "سلطة الكيل" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Fresh Kale mixed with roasted squash & goat cheese balls.  Topped with dates , grapes  & pecan nuts. Served with Thai dressing",
              ar: "مزيج من الكيل والخس والقرع المشوي مع شرائح التمر والعنب والطماطم الكرزية ، تقدم مع الصوص التايلندي المميز"
            }
          },
          {
            title: { en: "The Light Bowl", ar: "ذا لايت" },
            price: { en: "54", ar: "54" },
            description: {
              en: "A mix of lettuce with fresh kale topped with beans, roasted pumpkin and sweet corn. Seasoned with lemon sauce and fresh thyme leaves",
              ar: "مزيج من الخس مع الكيل الطازج  ،حبوب الفول واليقطين المحمص والذرة الحلوة. مع صوص الليمون و الزعتر"
            }
          },
          {
            title: { en: "Eggplant in Tahini", ar: "سلطة الباذنجان" },
            price: { en: "59", ar: "59" },
            description: {
              en: "Layers of roasted eggplant combined with cauliflower, quinoa & colored bell peppers . Served with maple tahini sauce",
              ar: "طبقات من الباذنجان المحمص مع القرنبيط والكينوا والفلفل الملون. تقدم مع صوص الطحينة مع الميبل"
            }
          },
        ]
      },
      {
        title: { en: "SLIDERS", ar: "سلايدرز" },
        dishes: [
          {
            title: { en: "Truffle  Sliders", ar: "ترافل سلايدرز" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Two beef patties  with delicious truffle sauce and onion rings",
              ar: "قطعتين  من برجر اللحم المشوي  مع صوص الترافل  اللذيذ  بالإضافة الى حلقات البصل"
            }
          },
          {
            title: { en: "Pesto Sliders", ar: "بيستو سلايدرز" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Two beef patties with pesto sauce, arugula, and cheery tomato",
              ar: "قطعتين من برجر اللحم المشو ي مع صوص البيستو والجرجير"
            }
          },
          {
            title: { en: "Chicken Sliders", ar: "دجاج سلايدرز" },
            price: { en: "47", ar: "47" },
            description: {
              en: "Freshly baked  bun filled with grilled chicken breast , topped with cheddar cheese , coleslaw salad and honey mustard sauce.",
              ar: "قطعتين من صدر  الدجاج المشوي  ، خليط الكول سلو المقرمش والجبنة الذائبه ،مع صوص الخردل بالعسل"
            }
          },
          {
            title: { en: "Chicken Tacos", ar: "تاكو الدجاج" },
            price: { en: "47", ar: "47" },
            description: {
              en: "Chicken Fajitas with reduced-fat cheese and guacamole in a tortilla bread",
              ar: "قطعتين من خبز التورتيا  محشية بالدجاج المشوي ، جواكمولي الافوكادو  مع  جبنة خفيفة"
            }
          },
          {
            title: { en: "Chicken Club Sandwich", ar: "كلوب الدجاج" },
            price: { en: "52", ar: "52" },
            description: {
              en: "Marinated grilled chicken club with lettuce, tomato and avocado in toasted brown bread",
              ar: "اربع قطع من كلوب  الدجاج المتبل  مع افوكادو  ،طماطم وخس  في خبز البر المحمص   (يقدم بارد)"
            }
          },
        ]
      },
      {
        title: { en: "PASTA & RISOTTO", ar: "الباستا والريزوتو" },
        dishes: [
          {
            title: { en: "Risotto Beef Sharwma", ar: "ريزوتو شاورما لحم" },
            price: { en: "79", ar: "79" },
            description: {
              en: "Beetroot risotto  adding beef shawarma with tahini sauce & parsley on top.",
              ar: "ريزوتو الشمندر مضافاً إليه شاورما اللحم مع البصل والسماق  ، صلصة الطحينة  المميزة"
            }
          },
          {
            title: { en: "Risotto Chicken Teryaki", ar: "ترياكي ريزوتو الزعفران" },
            price: { en: "76", ar: "76" },
            description: {
              en: "Saffron risotto topped with  teryaki chicken breast . Adding broccoli & sesame seeds.",
              ar: "ريزوتو الزعفران مع  البروكلي وقطع الدجاج بصوص الترياكي"
            }
          },
          {
            title: { en: "Rigatoni Chicken Pesto", ar: "بيستو باستا" },
            price: { en: "68", ar: "68" },
            description: {
              en: "Rigatoni in a sauce with a twist of pesto , grilled chicken , fresh mozzarella cheese, topped with cherry tomato & pine seeds",
              ar: "باستا مع صوص البيستو والصنوبر ، تقدم مع  اللدجاج المشوي وشرائح من الموزاريلا الطازجة"
            }
          },
          {
            title: { en: "Rigatoni Truffle", ar: "ترافل باستا" },
            price: { en: "67", ar: "67" },
            description: {
              en: "Rigatoni pasta  with truffle flavor and twist of sauteed wild mushrooms",
              ar: "باستا مع صوص الترافل مع  أنواع  من الفطر البري"
            }
          },
          {
            title: { en: "Fusilli Pasta", ar: "بينك باستا" },
            price: { en: "64", ar: "64" },
            description: {
              en: "pasta mixed with tomato sauce adding  cherry tomato , bell peppers and crunchy crumbs",
              ar: "باستا مع صلصة الطماطم الوردية والفلفل الحلو"
            }
          },
        ]
      },
      {
        title: { en: "DESSERTS", ar: "الحلويات" },
        dishes: [
          {
            title: { en: "Cookies cheesecake", ar: "تشيز كيك الكوكيز" },
            price: { en: "51", ar: "51" },
            description: {
              en: "Vanilla Cookies with chocolate cheese cake topped with chocolate ganache and fresh raspberry",
              ar: "تشيز كيك الكوكيز مع فاكهة التوت البري"
            }
          },
          {
            title: { en: "The Fabulous Lotus", ar: "ذا فابيلوس لوتس" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Lotus caramel cake",
              ar: "كيكة اللوتس مع مزيج من كريمة الكراميل  مغطاة بصوص اللوتس"
            }
          },
          {
            title: { en: "Pain perdu", ar: "بان بردو" },
            price: { en: "56", ar: "56" },
            description: {
              en: "Fried fresh brioche served with vanilla ice cream with homemade caramel sauce",
              ar: "بريوش  طازج يقدم مع آيس كريم الفانيلا وصوص الكراميل"
            }
          },
          {
            title: { en: "Chocolate fondant", ar: "شوكولا الفوندو" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Homemade chocolate fondant served with vanilla ice cream",
              ar: "شوكولا الفوندو تقدم مع آيس كريم الفانيلا يقدم ساخن"
            }
          },
          {
            title: { en: "Tiramisu", ar: "تيراميسو" },
            price: { en: "52", ar: "52" },
            description: {
              en: "Traditional Italian Tiramisu",
              ar: "تيراميسو إيطالي تقليدي"
            }
          },
          {
            title: { en: "date cake", ar: "كيكة التمر" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Date Cake with vanilla ice cream and saffron sauce",
              ar: "كيكة التمر مع صوص الزعفران وايسكريم الفانيلا - تقدم ساخنة"
            }
          },
          {
            title: { en: "Profiterole", ar: "بروفيتيرول" },
            price: { en: "56", ar: "56" },
            description: {
              en: "stuffed with vanilla pastry cream & coated with chocolate ganache Served with white chocolate sauce",
              ar: "محشوة بكريمة الفانيليا ومغطاة  بالشوكولاتة تقدم مع صوص الشوكولاتة البيضاء"
            }
          },
          {
            title: { en: "Brownies", ar: "براونيز" },
            price: { en: "58", ar: "58" },
            description: {
              en: "Served with fresh berries , Vanilla ice cream and chocolate sauce aside",
              ar: "براونيز على طريقة فوغ الخاصة ، تقدم مع أيسكريم الفانيلا و صوص الشوكولاته"
            }
          },
          {
            title: { en: "Chocolate Crepe", ar: "كريب الشوكولاته" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Homemade crepe stuffed with chocolate nutella and louts crumbs , topped with fresh mixed berries. Served with vanilla ice cream  and chocolate sauce",
              ar: "كريب الشوكولاته مع بسكويت اللوتس المطحون ، يقدم مع ايسكريم الفانيلا مع تشكيلة من الفواكه و صوص الشوكولاته"
            }
          },
          {
            title: { en: "Crème Brullee", ar: "كريم برولييه" },
            price: { en: "63", ar: "63" },
            description: {
              en: "Traditional crème brullé, topped with mixed berries",
              ar: "كريم بروليه الشهير ، يقدم مع  الفواكه الطازجة"
            }
          },
          {
            title: { en: "Cinnamon Roll", ar: "سينامون رولز" },
            price: { en: "54", ar: "54" },
            description: {
              en: "Three pieces of cinnamon rolls , served with hot caramel pecans and cream",
              ar: "ثلاث قطع من لفائف السينامون   بالقرفة ،تقدم مع جوز البيكان بالكراميل الساخن والكريمة"
            }
          },
          {
            title: { en: "Pistachio Ashta", ar: "بريوش قشطة بستاشيو" },
            price: { en: "53", ar: "53" },
            description: {
              en: "Crunchy brioche bread with two layers of Ashta pistachio cream",
              ar: "بريوش محمص مع  طبقتين من القشطة الناعمة وكريمة الفستق المنعشة"
            }
          },
        ]
      },
      {
        title: { en: "HOT BEVERAGES", ar: "المشروبات الساخنة" },
        dishes: [
          {
            title: { en: "Dark Hot Chocolate", ar: "Dark Hot Chocolate" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Espresso", ar: "Espresso" },
            price: { en: "15", ar: "15" },
          },
          {
            title: { en: "Latte", ar: "Latte" },
            price: { en: "26", ar: "26" },
          },
          {
            title: { en: "Affogato", ar: "Affogato" },
            price: { en: "28", ar: "28" },
          },
          {
            title: { en: "Stawberry Coffee", ar: "Stawberry Coffee" },
            price: { en: "23", ar: "23" },
          },
          {
            title: { en: "Caramel Machiato", ar: "Caramel Machiato" },
            price: { en: "27", ar: "27" },
          },
          {
            title: { en: "Cortado", ar: "Cortado" },
            price: { en: "22", ar: "22" },
          },
          {
            title: { en: "Spanich Latte", ar: "Spanich Latte" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Cappuccino", ar: "Cappuccino" },
            price: { en: "26", ar: "26" },
          },
          {
            title: { en: "Flat White", ar: "Flat White" },
            price: { en: "23", ar: "23" },
          },
          {
            title: { en: "Americano", ar: "Americano" },
            price: { en: "19", ar: "19" },
          },
          {
            title: { en: "Filttered coffee", ar: "Filttered coffee" },
            price: { en: "18", ar: "18" },
          },
          {
            title: { en: "Mocha", ar: "Mocha" },
            price: { en: "26", ar: "26" },
          },
          {
            title: { en: "Macchiato", ar: "Macchiato" },
            price: { en: "17", ar: "17" },
          },
          {
            title: { en: "Arabic Coffee", ar: "Arabic Coffee" },
            price: { en: "46", ar: "46" },
            description: {
              en: "Served with Seasonal Dates",
              ar: ""
            }
          },
          {
            title: { en: "Tea", ar: "Tea" },
            price: { en: "18", ar: "18" },
          },
        ]
      },
      {
        title: { en: "COFFEE COOLERS", ar: "القهوة المثلجة" },
        dishes: [
          {
            title: { en: "Cappuccino Freddo", ar: "Cappuccino Freddo" },
            price: { en: "28", ar: "28" },
          },
          {
            title: { en: "Iced Mocha", ar: "Iced Mocha" },
            price: { en: "28", ar: "28" },
          },
          {
            title: { en: "Vogue Ice Latte", ar: "Vogue Ice Latte" },
            price: { en: "26", ar: "26" },
          },
          {
            title: { en: "Iced Spanish Latte", ar: "Iced Spanish Latte" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Iced Americano", ar: "Iced Americano" },
            price: { en: "18", ar: "18" },
          },
          {
            title: { en: "Iced Vanilla Flat White", ar: "Iced Vanilla Flat White" },
            price: { en: "26", ar: "26" },
          },
          {
            title: { en: "Iced Dalgona", ar: "Iced Dalgona" },
            price: { en: "24", ar: "24" },
          },
        ]
      },
      {
        title: { en: "COLD BEVERAGES", ar: "المشروبات الباردة" },
        dishes: [
          {
            title: { en: "Iced Mango Passion", ar: "Iced Mango Passion" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Strawberry Mojito", ar: "Strawberry Mojito" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Blue Mojito", ar: "Blue Mojito" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Passion Mojito", ar: "Passion Mojito" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Wild Mint Mojito", ar: "Wild Mint Mojito" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Iced Tea Peach", ar: "Iced Tea Peach" },
            price: { en: "22", ar: "22" },
          },
          {
            title: { en: "Frozen Berries & Mint", ar: "Frozen Berries & Mint" },
            price: { en: "34", ar: "34" },
          },
          {
            title: { en: "Strawberry Lemonade", ar: "Strawberry Lemonade" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Frozen lemon mint", ar: "Frozen lemon mint" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Oreo Shake", ar: "Oreo Shake" },
            price: { en: "34", ar: "34" },
          },
          {
            title: { en: "Iced Chocoate Mint", ar: "Iced Chocoate Mint" },
            price: { en: "32", ar: "32" },
          },
          {
            title: { en: "Fresh Orange Juice", ar: "Fresh Orange Juice" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Fresh Carrot Juice", ar: "Fresh Carrot Juice" },
            price: { en: "29", ar: "29" },
          },
          {
            title: { en: "Fresh Watermelon Juice", ar: "Fresh Watermelon Juice" },
            price: { en: "24", ar: "24" },
          },
          {
            title: { en: "Fresh Green Apple Juice", ar: "Fresh Green Apple Juice" },
            price: { en: "28", ar: "28" },
          },
          {
            title: { en: "Soft Drinks", ar: "Soft Drinks" },
            price: { en: "12", ar: "12" },
          },
          {
            title: { en: "Aqua Pana Water (250 ml)", ar: "Aqua Pana Water (250 ml)" },
            price: { en: "8", ar: "8" },
          },
          {
            title: { en: "Aqua Pana Water (750 ml)", ar: "Aqua Pana Water (750 ml)" },
            price: { en: "18", ar: "18" },
          },
          {
            title: { en: "Small Sparkling Water", ar: "Small Sparkling Water" },
            price: { en: "14", ar: "14" },
          },
        ]
      },
    ]
  }
};



// WEBPACK FOOTER //
// ./src/SiteData.js